'kiwi public';

import GlobalApi from '@/libs/GlobalApi';
import ChannelInfo from './ChannelInfo';
import ChannelBanlist from './ChannelBanlist';
import ChannelInvitelist from './ChannelInvitelist';
import BufferSettings from './BufferSettings';

// Helper to generate Vue's computed methods for getting/setting settings.
function generateComputedSetting(setting) {
  return {
    get: function get() {
      return this.buffer.setting(setting);
    },
    set: function set(newVal) {
      return this.buffer.setting(setting, newVal);
    }
  };
}
export default {
  components: {
    ChannelInfo: ChannelInfo,
    ChannelBanlist: ChannelBanlist,
    ChannelInvitelist: ChannelInvitelist,
    BufferSettings: BufferSettings
  },
  props: ['network', 'buffer', 'sidebarState'],
  data: function data() {
    return {
      pluginUiElements: GlobalApi.singleton().sideBarPlugins,
      accessTab: 'banlist'
    };
  },
  computed: {
    settingShowJoinParts: generateComputedSetting('show_joinparts'),
    settingShowTopics: generateComputedSetting('show_topics'),
    settingShowNickChanges: generateComputedSetting('show_nick_changes'),
    settingShowModeChanges: generateComputedSetting('show_mode_changes'),
    settingColouredNicklist: generateComputedSetting('coloured_nicklist'),
    settingExtraFormatting: generateComputedSetting('extra_formatting'),
    settingShareTyping: generateComputedSetting('share_typing'),
    areWeAnOp: function areWeAnOp() {
      return this.buffer.isUserAnOp(this.buffer.getNetwork().nick);
    }
  }
};
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["components"]) window._kiwi_exports["components"] = {};
window._kiwi_exports["components"]["SidebarSectionSettings"]
window._kiwi_exports.components.SidebarSectionSettings = (typeof exports !== 'undefined' ? (exports.default || exports) : (typeof module !== 'undefined' && module.exports ? (module.exports.default || module.exports) : {}));
